import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './careers.css'

const Careers = (props) => {
  return (
    <div id="careers" className="careers-container1">
      <Helmet>
        <title>Careers at SCMmax | Build the Future of AI Procurement</title>
        <meta
          name="description"
          content="Join SCMmax in building the future of procurement intelligence. We're looking for procurement experts and AI/ML engineers."
        />
        <meta
          property="og:title"
          content="Careers at SCMmax | Build the Future of AI Procurement"
        />
        <meta
          property="og:description"
          content="Join SCMmax in building the future of procurement intelligence. We're looking for procurement experts and AI/ML engineers."
        />
        <link rel="canonical" href="https://scmmax.com/careers" />
        <meta property="og:url" content="https://scmmax.com/careers" />
      </Helmet>
      <NavbarInteractive
        home={
          <Fragment>
            <span className="careers-text10">Home</span>
          </Fragment>
        }
        text={
          <Fragment>
            <span className="careers-text11"> Apollo</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="careers-text12">About Us</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="careers-text13">Home</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="careers-text14">Products</span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="careers-text15">Services</span>
          </Fragment>
        }
        text8={
          <Fragment>
            <span className="careers-text16"> Apollo</span>
          </Fragment>
        }
        text51={
          <Fragment>
            <span className="careers-text17">Careers</span>
          </Fragment>
        }
        products={
          <Fragment>
            <span className="careers-text18">Products</span>
          </Fragment>
        }
        register={
          <Fragment>
            <span className="careers-text19">request Demo</span>
          </Fragment>
        }
        services={
          <Fragment>
            <span className="careers-text20">Services</span>
          </Fragment>
        }
        services2={
          <Fragment>
            <span className="careers-text21">About Us</span>
          </Fragment>
        }
        rootClassName="navbar-interactiveroot-class-name3"
        primaryButtonTest={
          <Fragment>
            <span className="careers-text22">Request Demo</span>
          </Fragment>
        }
      ></NavbarInteractive>
      <div className="careers-thq-hero-outer-elm">
        <div className="careers-thq-hero-inner-elm">
          <div className="careers-thq-eyebrow-elm1">
            <div className="careers-container2"></div>
            <span className="careers-text23"> Join the Team</span>
          </div>
          <div className="careers-thq-headline-column-elm1">
            <span className="careers-thq-headline1-elm1">
              Build the future of
            </span>
            <span className="careers-thq-headline2-elm1">
              procurement intelligence.
            </span>
          </div>
          <span className="careers-thq-subheading-elm1">
            We hire in two tracks — procurement professionals who want to work
            alongside AI, and AI engineers who want to work on hard domain
            problems. Both are essential. Neither is secondary.
          </span>
          <div className="careers-thq-stats-row-elm">
            <div className="careers-thq-stat1-elm">
              <span className="careers-thq-text-elm1">16</span>
              <span className="careers-text24">
                Agents working for your team
              </span>
            </div>
            <div className="careers-thq-stat2-elm">
              <span className="careers-thq-text-elm2">90</span>
              <span className="careers-text25">
                Days to go live with a new customer
              </span>
            </div>
            <div className="careers-thq-stat3-elm">
              <span className="careers-thq-text-elm3">3-8%</span>
              <span className="careers-text26">
                Typical cost reduction in first category scan
              </span>
            </div>
            <div className="careers-thq-stat4-elm">
              <span className="careers-thq-text-elm4">0</span>
              <span className="careers-text27">
                Customer data leaves their environment
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="careers-container4">
            <Script
              html={`<div style="line-height:0;margin:0;padding:0;display:block;overflow:hidden;width:100%;">
  <svg viewBox="0 0 1440 48" fill="none" preserveAspectRatio="none" style="display:block;width:100%;height:48px;">
    <path d="M0 0 L1440 0 L1440 24 Q1080 48 720 40 Q360 32 0 48 Z" fill="#0F1421" />
    <path d="M0 48 Q360 32 720 40 Q1080 48 1440 24 L1440 48 Z" fill="#F4F6FA" />
  </svg>
</div>`}
            ></Script>
          </div>
        </div>
      </div>
      <div className="careers-thq-open-roles-section-elm">
        <div className="careers-thq-roles-inner-elm">
          <div className="careers-thq-roles-header-elm">
            <div className="careers-thq-eyebrow-elm2">
              <div className="careers-thq-dash-elm"></div>
              <span className="careers-text28">Open Roles</span>
            </div>
            <div className="careers-thq-title-column-elm1">
              <span className="careers-text29">Who we&apos;re</span>
              <span className="careers-text30">looking for right now.</span>
            </div>
            <span className="careers-thq-sub-title-elm">
              Procurement knowledge is the foundation of everything we do. We
              also need a small number of exceptional AI/ML engineers who can
              build the intelligence layer that makes Apollo smarter every day.
              Both tracks are critical — and both are hard to do well.
            </span>
          </div>
          <div className="careers-thq-track-pills-elm">
            <div className="careers-thq-pill1-elm">
              <div className="careers-thq-dot-elm1"></div>
              <span className="careers-text31">Procurement Track</span>
              <span className="careers-thq-sub-text-elm1">
                deep domain, customer-facing
              </span>
            </div>
            <div className="careers-thq-pill2-elm">
              <div className="careers-thq-dot-elm2"></div>
              <span className="careers-text32">Engineering Track</span>
              <span className="careers-thq-sub-text-elm2">
                AI/ML, Graphs, semantics
              </span>
            </div>
          </div>
          <div className="careers-container5">
            <div className="careers-container6">
              <Script
                html={`<!--
  ════════════════════════════════════════════════════════════
  SCMMAX APOLLO — JOB CARDS CODE EMBED
  Paste this entire block into a TeleportHQ Code Embed element.
  Width: 100% | No padding on the Code Embed container.

  TO ADD A ROLE:
    Duplicate one of the .jc-card divs and update:
    - id="your-new-id"
    - onclick="jcToggle('your-new-id')"
    - All tags, title, headline, body content, email link

  TO REMOVE A ROLE:
    Delete the entire .jc-card div for that role.
    The "no open roles" message appears automatically.
  ════════════════════════════════════════════════════════════
-->

<style>
  .jc-wrap {
    font-family: 'DM Sans', system-ui, sans-serif;
    width: 100%;
  }

  /* TRACK PILLS */
  .jc-pills {
    display: flex;
    gap: 12px;
    margin-bottom: 48px;
    flex-wrap: wrap;
  }

  .jc-pill {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px;
    border-radius: 8px;
    border: 1px solid #E8ECF4;
    background: #FFFFFF;
  }

  .jc-pill-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .jc-pill-dot.brass {
    background: #C9933A;
  }

  .jc-pill-dot.teal {
    background: #00B8A0;
  }

  .jc-pill-label {
    font-size: .78rem;
    font-weight: 500;
    color: #253050;
  }

  .jc-pill-count {
    font-size: .72rem;
    color: #7A8AAE;
    margin-left: 4px;
  }

  /* CARD */
  .jc-card {
    background: #FFFFFF;
    border: 1px solid #E8ECF4;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 20px;
    transition: box-shadow 200ms, border-color 200ms;
  }

  .jc-card:hover {
    border-color: #C8D0E0;
    box-shadow: 0 8px 32px rgba(15, 20, 33, .08);
  }

  .jc-header {
    padding: 32px 40px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    cursor: pointer;
  }

  .jc-meta {
    flex: 1;
  }

  .jc-tags {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }

  .jc-tag {
    padding: 3px 10px;
    border-radius: 4px;
    font-size: .6rem;
    font-weight: 500;
    letter-spacing: .08em;
    text-transform: uppercase;
  }

  .jc-tag.procurement {
    background: rgba(201, 147, 58, .1);
    border: 1px solid rgba(201, 147, 58, .25);
    color: #C9933A;
  }

  .jc-tag.engineering {
    background: rgba(0, 184, 160, .08);
    border: 1px solid rgba(0, 184, 160, .2);
    color: #00B8A0;
  }

  .jc-tag.type {
    background: #F4F6FA;
    border: 1px solid #E8ECF4;
    color: #4A5880;
  }

  .jc-tag.loc {
    background: rgba(37, 48, 80, .08);
    border: 1px solid rgba(37, 48, 80, .2);
    color: #3A4870;
  }

  .jc-title {
    font-family: 'Fraunces', Georgia, serif;
    font-size: 1.35rem;
    font-weight: 300;
    letter-spacing: -.02em;
    color: #0F1421;
    margin-bottom: 8px;
    transition: color 180ms;
  }

  .jc-header:hover .jc-title {
    color: #C9933A;
  }

  .jc-headline {
    font-size: .85rem;
    color: #4A5880;
    line-height: 1.6;
    max-width: 640px;
  }

  .jc-toggle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #F4F6FA;
    border: 1px solid #E8ECF4;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 180ms;
    cursor: pointer;
  }

  .jc-toggle svg {
    transition: transform 250ms;
  }

  .jc-card.open .jc-toggle {
    background: #C9933A;
    border-color: #C9933A;
  }

  .jc-card.open .jc-toggle svg {
    transform: rotate(45deg);
  }

  .jc-card.open .jc-toggle svg path {
    stroke: #fff;
  }

  .jc-body {
    max-height: 0;
    overflow: hidden;
    transition: max-height 420ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .jc-card.open .jc-body {
    max-height: 3000px;
  }

  .jc-inner {
    padding: 32px 40px 40px;
    border-top: 1px solid #E8ECF4;
  }

  .jc-sec-title {
    font-size: .6rem;
    font-weight: 500;
    letter-spacing: .14em;
    text-transform: uppercase;
    color: #7A8AAE;
    margin-bottom: 12px;
    margin-top: 28px;
  }

  .jc-sec-title:first-child {
    margin-top: 0;
  }

  .jc-desc {
    font-size: .88rem;
    color: #4A5880;
    line-height: 1.75;
  }

  .jc-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .jc-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: .85rem;
    color: #3A4870;
    line-height: 1.6;
  }

  .jc-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #C9933A;
    flex-shrink: 0;
    margin-top: 7px;
  }

  .jc-dot.teal {
    background: #00B8A0;
  }

  .jc-divider {
    height: 1px;
    background: #E8ECF4;
    margin: 28px 0;
  }

  .jc-apply {
    background: #F4F6FA;
    border: 1px solid #E8ECF4;
    border-radius: 10px;
    padding: 28px;
    margin-top: 32px;
  }

  .jc-apply-title {
    font-family: 'Fraunces', Georgia, serif;
    font-size: 1.1rem;
    font-weight: 300;
    color: #0F1421;
    margin-bottom: 6px;
  }

  .jc-apply-sub {
    font-size: .82rem;
    color: #4A5880;
    line-height: 1.65;
    margin-bottom: 20px;
  }

  .jc-checklist {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px;
  }

  .jc-check {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: .82rem;
    color: #3A4870;
    line-height: 1.55;
  }

  .jc-num {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #C9933A;
    color: #fff;
    font-size: .6rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .jc-note {
    font-size: .75rem;
    color: #4A5880;
    font-style: italic;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: rgba(201, 147, 58, .06);
    border-left: 3px solid #C9933A;
    border-radius: 0 4px 4px 0;
    line-height: 1.6;
  }

  .jc-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 13px 28px;
    background: #C9933A;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-family: 'DM Sans', system-ui, sans-serif;
    font-size: .75rem;
    font-weight: 500;
    letter-spacing: .06em;
    text-transform: uppercase;
    cursor: pointer;
    text-decoration: none;
    transition: background 150ms;
  }

  .jc-btn:hover {
    background: #E8C278;
  }

  .jc-no-roles {
    background: #FFFFFF;
    border: 1px solid #E8ECF4;
    border-radius: 12px;
    padding: 64px 40px;
    text-align: center;
    display: none;
  }

  .jc-no-roles.show {
    display: block;
  }

  .jc-no-title {
    font-family: 'Fraunces', Georgia, serif;
    font-size: 1.3rem;
    font-weight: 300;
    color: #253050;
    margin-bottom: 8px;
  }

  .jc-no-sub {
    font-size: .88rem;
    color: #7A8AAE;
    line-height: 1.65;
  }

  @media(max-width: 767px) {
    .jc-header {
      padding: 24px 20px;
    }

    .jc-inner {
      padding: 24px 20px 28px;
    }

    .jc-apply {
      padding: 20px;
    }
  }
</style>

<div class="jc-wrap">

  <!-- TRACK PILLS -->
  <div class="jc-pills">
    <div class="jc-pill">
      <div class="jc-pill-dot brass"></div>
      <span class="jc-pill-label">Procurement Track</span>
      <span class="jc-pill-count">— deep domain, customer-facing</span>
    </div>
    <div class="jc-pill">
      <div class="jc-pill-dot teal"></div>
      <span class="jc-pill-label">Engineering Track</span>
      <span class="jc-pill-count">— AI/ML, Graphs, Semantics</span>
    </div>
  </div>

  <!-- ═══ CARD 1: FDE ═══ -->
  <div class="jc-card" id="jc-fde">
    <div class="jc-header" onclick="jcToggle('jc-fde')">
      <div class="jc-meta">
        <div class="jc-tags">
          <span class="jc-tag procurement">● Procurement Track</span>
          <span class="jc-tag type">Full Time</span>
          <span class="jc-tag loc">Customer Sites in US, EU & India </span>
        </div>
        <div class="jc-title">Forward Deployed Engineer — Procurement Intelligence</div>
        <div class="jc-headline">Embed with enterprise customers. Configure Apollo to their spend context. Enable their
          teams to unlock real value from day one.</div>
      </div>
      <div class="jc-toggle">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7 1V13M1 7H13" stroke="#7A8AAE" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>
    </div>
    <div class="jc-body">
      <div class="jc-inner">

        <div class="jc-sec-title">About the Role</div>
        <p class="jc-desc">This is not a typical consulting role. You will be embedded with customers, configuring
          Apollo to their specific spend context, enabling their procurement teams, and ensuring the platform delivers
          measurable results from day one. You will be the bridge between deep procurement expertise and AI-powered
          intelligence — and the person customers trust to make it real.</p>

        <div class="jc-divider"></div>

        <div class="jc-sec-title">What We're Looking For</div>
        <div class="jc-list">
          <div class="jc-item">
            <div class="jc-dot"></div>At least 5 years of hands-on buying experience across multiple direct material
            categories
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Experience leading or contributing to at least one end-to-end digital
            transformation in a procurement context
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Comfortable working with ERP data, spend extracts, and supplier master data — able
            to bridge the conversation between procurement and IT teams
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Strong communicator who can run training sessions, present findings to leadership,
            and write clear monthly value reports
          </div>
        </div>

        <div class="jc-divider"></div>

        <div class="jc-sec-title">What You'll Do</div>
        <div class="jc-list">
          <div class="jc-item">
            <div class="jc-dot teal"></div>Configure Apollo to meet each customer's specific procurement context and
            category profile
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div>Enable the customer's procurement team to use Apollo effectively — training,
            questions, building confidence
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div>Work with SCMMAX's backend team to flag improvement opportunities and resolve
            issues
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div>Deliver monthly reporting on value created — savings identified, decisions
            supported, efficiency gains
          </div>
        </div>

        <div class="jc-divider"></div>

        <div class="jc-apply">
          <div class="jc-apply-title">How to Apply</div>
          <div class="jc-apply-sub">Send your CV and a cover letter to <strong>careers@scmmax.com</strong> with subject
            <em>"FDE Application — [Your Name]"</em>. Your cover letter must address all four points.</div>
          <div class="jc-checklist">
            <div class="jc-check">
              <div class="jc-num">1</div>The categories you have managed and the approximate annual spend you were
              responsible for
            </div>
            <div class="jc-check">
              <div class="jc-num">2</div>Specific procurement cost reductions you have achieved and how you achieved
              them
            </div>
            <div class="jc-check">
              <div class="jc-num">3</div>How you have used technology or data to improve procurement outcomes
            </div>
            <div class="jc-check">
              <div class="jc-num">4</div>Having read about Apollo — how do you see it creating value for enterprise
              procurement teams, and why does that excite you?
            </div>
          </div>
          <div class="jc-note">Applications without a cover letter addressing all four points will not be reviewed. This
            is intentional — we want to hear how you think, not just what you've done.</div>
          <a href="mailto:careers@scmmax.com?subject=FDE Application — [Your Name]" class="jc-btn">
            Apply for this Role
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 7H13M8 2L13 7L8 12" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </a>
        </div>

      </div>
    </div>
  </div>
  <!-- ═══ END CARD 1 ═══ -->


  <!-- ═══ CARD 2: AI/ML ═══ -->
  <div class="jc-card" id="jc-aiml">
    <div class="jc-header" onclick="jcToggle('jc-aiml')">
      <div class="jc-meta">
        <div class="jc-tags">
          <span class="jc-tag engineering">● Engineering Track</span>
          <span class="jc-tag type">Full Time</span>
          <span class="jc-tag loc">Remote in US / Canada / India</span>
        </div>
        <div class="jc-title">AI/ML Engineer — Procurement Intelligence</div>
        <div class="jc-headline">Build the models that make Apollo smarter. Price forecasting, knowledge graphs,
          semantic resolution — on real procurement data with real consequences.</div>
      </div>
      <div class="jc-toggle">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7 1V13M1 7H13" stroke="#7A8AAE" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>
    </div>
    <div class="jc-body">
      <div class="jc-inner">

        <div class="jc-sec-title">About the Role</div>
        <p class="jc-desc">Apollo's intelligence layer is built by a small team of AI/ML engineers who care deeply about
          getting the domain right. You won't need procurement experience — but you will need genuine curiosity about
          how enterprise procurement works. The problems here are genuinely interesting: supplier pricing is noisy and
          adversarial, category data is inconsistent and incomplete, and the decisions Apollo supports have real
          financial consequences for large businesses. You will work directly with our procurement domain experts to
          turn real-world problems into robust, production-grade AI.</p>

        <div class="jc-divider"></div>

        <div class="jc-sec-title">What We're Looking For</div>
        <div class="jc-list">
          <div class="jc-item">
            <div class="jc-dot"></div>Strong ML foundations with hands-on experience building and deploying models in
            production
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Deep interest or experience in one or more of: time-series and price forecasting,
            knowledge graph construction, semantic similarity and entity resolution, or LLM integration and grounding
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Comfortable with messy, real-world data — ERP extracts, supplier databases,
            commodity price feeds, inconsistent master data
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Curious about how AI outputs get used in high-stakes decisions — not just model
            metrics, but whether the recommendation is actually useful
          </div>
          <div class="jc-item">
            <div class="jc-dot"></div>Able to explain model behaviour and limitations clearly to non-technical
            procurement professionals
          </div>
        </div>

        <div class="jc-divider"></div>

        <div class="jc-sec-title">What You'll Work On</div>
        <div class="jc-list">
          <div class="jc-item">
            <div class="jc-dot teal"></div><strong>Price forecasting</strong> — predicting commodity and raw material
            price movements across categories, feeding directly into Apollo's buying recommendations
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div><strong>Knowledge graph & semantics</strong> — building Apollo's
            understanding of relationships between materials, suppliers, categories, and market conditions
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div><strong>Entity resolution & deduplication</strong> — turning inconsistent ERP
            master data into clean, AI-interpretable golden records
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div><strong>Context graph development</strong> — helping Apollo understand the
            relational context behind procurement decisions
          </div>
          <div class="jc-item">
            <div class="jc-dot teal"></div><strong>LLM integration</strong> — grounding Apollo's outputs in real
            procurement data, ensuring recommendations are specific, defensible, and actionable
          </div>
        </div>

        <div class="jc-divider"></div>

        <div class="jc-apply">
          <div class="jc-apply-title">How to Apply</div>
          <div class="jc-apply-sub">Send your CV and a cover letter to <strong>careers@scmmax.com</strong> with subject
            <em>"AI/ML Application — [Your Name]"</em>.</div>
          <div class="jc-checklist">
            <div class="jc-check">
              <div class="jc-num">1</div>A specific ML project you've built end to end — the problem, what you built,
              how you evaluated it, what you'd do differently
            </div>
            <div class="jc-check">
              <div class="jc-num">2</div>Your experience with time-series forecasting, knowledge graphs, semantic
              models, or LLM integration — with concrete examples
            </div>
            <div class="jc-check">
              <div class="jc-num">3</div>Having read about Apollo — which technical problem here interests you most, and
              what's your instinct on how to approach it?
            </div>
          </div>
          <div class="jc-note">We are hiring very few people for the engineering track. We are looking for depth and
            genuine curiosity about the domain — not a standard ML profile.</div>
          <a href="mailto:careers@scmmax.com?subject=AI/ML Application — [Your Name]" class="jc-btn">
            Apply for this Role
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 7H13M8 2L13 7L8 12" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </a>
        </div>

      </div>
    </div>
  </div>
  <!-- ═══ END CARD 2 ═══ -->


  <!-- ADD NEW CARDS ABOVE THIS LINE -->


  <div class="jc-no-roles" id="jc-no-roles">
    <div class="jc-no-title">No open roles right now</div>
    <div class="jc-no-sub">We're always interested in exceptional talent — procurement or engineering.<br>Send your CV to
      <strong>careers@scmmax.com</strong> and we'll keep you in mind.</div>
  </div>

</div>

<script>
  function jcToggle(id) {
  var el = document.getElementById(id);
  if (el) el.classList.toggle('open');
}
(function() {
  var cards = document.querySelectorAll('.jc-card');
  var noRoles = document.getElementById('jc-no-roles');
  if (cards.length === 0 && noRoles)
    noRoles.classList.add('show');
})();
</script>`}
              ></Script>
            </div>
          </div>
        </div>
      </div>
      <div className="careers-thq-culture-outer-section-elm">
        <div className="careers-thq-culture-inner-r-ow-elm">
          <div className="careers-thq-left-column-elm">
            <div className="careers-thq-eyebrow-elm3">
              <div className="careers-container7"></div>
              <span className="careers-text33">Life at SCMMAX</span>
            </div>
            <div className="careers-thq-headline-column-elm2">
              <span className="careers-thq-headline1-elm2">
                Built by people who
              </span>
              <span className="careers-thq-headline2-elm2">
                know what they&apos;re doing.
              </span>
            </div>
            <span className="careers-thq-subheading-elm2">
              Procurement knowledge is non-negotiable here — even on the
              engineering side. Our AI team works directly with procurement
              professionals who have managed real spend. That close
              collaboration is what makes Apollo&apos;s outputs actually useful,
              not just technically impressive.
            </span>
            <div className="careers-thq-culture-points-elm">
              <div className="careers-thq-cp1-elm">
                <div className="careers-thq-icon-box-elm1">
                  <span className="careers-text34">🎯</span>
                </div>
                <div className="careers-thq-text-column-elm1">
                  <span className="careers-text35">Domain first, always</span>
                  <span className="careers-text36">
                    Every technical decision gets pressure-tested against real
                    procurement scenarios. If a model output wouldn&apos;t make
                    sense to an experienced CPO, it&apos;s not good enough.
                  </span>
                </div>
              </div>
              <div className="careers-thq-cp2-elm">
                <div className="careers-thq-icon-box-elm2">
                  <span className="careers-text37">📊</span>
                </div>
                <div className="careers-thq-text-column-elm2">
                  <span className="careers-text38">Outcomes over activity</span>
                  <span className="careers-text39">
                    We measure value created, not hours logged. Every customer
                    engagement has a clear savings target — and a monthly report
                    to prove it.
                  </span>
                </div>
              </div>
              <div className="careers-thq-cp3-elm">
                <div className="careers-thq-icon-box-elm3">
                  <span className="careers-text40">🔧</span>
                </div>
                <div className="careers-thq-text-column-elm3">
                  <span className="careers-text41">
                    Engineering and domain work together
                  </span>
                  <span className="careers-text42">
                    Our FDEs send field observations directly to our AI team.
                    There is no wall between customer insight and product
                    development.
                  </span>
                </div>
              </div>
              <div className="careers-thq-cp4-elm">
                <div className="careers-thq-icon-box-elm4">
                  <span className="careers-text43">🌏</span>
                </div>
                <div className="careers-thq-text-column-elm4">
                  <span className="careers-text44">Enterprise scale</span>
                  <span className="careers-text45">
                    We operate across multiple continents and serve enterprise
                    businesses managing many billions in direct spend. The
                    conversations are strategic and the stakes are real.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="careers-thq-right-column-elm">
            <div className="careers-thq-culture-card-elm">
              <div className="careers-thq-card-hearder-elm">
                <span className="careers-thq-title-elm">
                  Four profiles that thrive here
                </span>
                <span className="careers-text46">
                  We don&apos;t hire for roles — we hire for capability and
                  curiosity.  These are the people who do exceptional work at
                  SCMMAX.
                </span>
              </div>
              <div className="careers-thq-profile1-elm">
                <div className="careers-thq-avtar-elm1">
                  <span className="careers-thq-short-text-elm1">CE</span>
                </div>
                <div className="careers-thq-profile-text-elm1">
                  <span className="careers-thq-name-elm1">
                    The Category Expert
                  </span>
                  <span className="careers-thq-role-elm1">
                    Deep category knowledge · Negotiation track record ·
                    Data-literate
                  </span>
                  <span className="careers-thq-quote-elm1">
                    &quot;I&apos;ve managed $500M of chemicals and packaging
                    category spend. I know where the money leaks — and I want to
                    prove it systematically.&quot;
                  </span>
                </div>
              </div>
              <div className="careers-thq-profile2-elm">
                <div className="careers-thq-avtar-elm2">
                  <span className="careers-thq-short-text-elm2">DT</span>
                </div>
                <div className="careers-thq-profile-text-elm2">
                  <span className="careers-thq-name-elm2">
                    The Digital Transformer
                  </span>
                  <span className="careers-thq-role-elm2">
                    Procurement + ERP experience · Change management ·
                    Analytical
                  </span>
                  <span className="careers-thq-quote-elm2">
                    &quot;I was a buyer. Then I led SAP Ariba rollout for a
                    3,000-supplier base. I know what breaks during
                    implementation — and how to prevent it.&quot;
                  </span>
                </div>
              </div>
              <div className="careers-thq-profile3-elm">
                <div className="careers-thq-avtar-elm3">
                  <span className="careers-thq-short-text-elm3">DB</span>
                </div>
                <div className="careers-thq-profile-text-elm3">
                  <span className="careers-thq-name-elm3">
                    The Data-First Buyer
                  </span>
                  <span className="careers-thq-role-elm3">
                    Spend analytics · Should-cost modelling · Supplier
                    intelligence
                  </span>
                  <span className="careers-thq-quote-elm3">
                    &quot;I cleaned our data &amp; built category spend
                    dashboards from scratch. Numbers tell the story — you just
                    need to ask the right questions.&quot;
                  </span>
                </div>
              </div>
              <div className="careers-thq-profile4-elm">
                <div className="careers-thq-avtar-elm4">
                  <span className="careers-thq-short-text-elm4">AB</span>
                </div>
                <div className="careers-thq-profile-text-elm4">
                  <span className="careers-thq-name-elm4">
                    The AI/ML Builder
                  </span>
                  <span className="careers-thq-role-elm4">
                    Negotiation Templates· Price forecasting · Graphs · Context
                    modelling
                  </span>
                  <span className="careers-thq-quote-elm4">
                    &quot;I&apos;ve built price prediction models for commodity
                    markets. Procurement data is messy and adversarial —
                    that&apos;s what makes it interesting.&quot;
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="careers-thq-cta-strip-elm">
        <div className="careers-thq-cta-inner-elm">
          <div className="careers-thq-text-column-elm5">
            <div className="careers-thq-title-column-elm2">
              <span className="careers-text47">
                Don&apos;t see the right role?
              </span>
              <span className="careers-text48">Reach out anyway.</span>
            </div>
            <span className="careers-thq-subtitle-elm">
              Exceptional procurement expertise or AI/ML depth — we always want
              to hear from you.
            </span>
          </div>
          <div className="careers-thq-button-row-elm">
            <a 
              href="mailto:careers@scmmax.com" 
              style={{ textDecoration: 'none' }}
            >
              <span className="careers-text49" style={{ cursor: 'pointer' }}>
                SEND YOUR CV
              </span>
            </a>
            <Link to="/about-us" style={{ textDecoration: 'none' }}>
              <span className="careers-text50" style={{ cursor: 'pointer' }}>
                LEARN ABOUT APOLLO
              </span>
            </Link>
          </div>
        </div>
      </div>
      <Footer
        blog={
          <Fragment>
            <span className="careers-text51">Blog</span>
          </Fragment>
        }
        text={
          <Fragment>
            <span className="careers-text52">
              © 2026 SCMmax Consulting Inc. All rights reserved.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        about={
          <Fragment>
            <span className="careers-text53">About</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="careers-text54">Always Ready. Always Ahead.</span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="careers-text55">
              AI-powered procurement intelligence for enterprise buying teams.
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="careers-text56">Privacy Policy</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="careers-text57">Terms of Service</span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="careers-text58"> Apollo</span>
          </Fragment>
        }
        careers={
          <Fragment>
            <span className="careers-text59">Careers</span>
          </Fragment>
        }
        company={
          <Fragment>
            <span className="careers-text60">COMPANY</span>
          </Fragment>
        }
        product={
          <Fragment>
            <span className="careers-text61">PRODUCT</span>
          </Fragment>
        }
        services={
          <Fragment>
            <span className="careers-text62">SERVICES</span>
          </Fragment>
        }
        contactUs={
          <Fragment>
            <span className="careers-text63">Contact Us</span>
          </Fragment>
        }
        consulting={
          <Fragment>
            <span className="careers-text64">Consulting</span>
          </Fragment>
        }
        dataServices={
          <Fragment>
            <span className="careers-text65">Data Services</span>
          </Fragment>
        }
        productivity={
          <Fragment>
            <span className="careers-text66">Productivity</span>
          </Fragment>
        }
        dataAnalytics={
          <Fragment>
            <span className="careers-text67">Data &amp; Analytics</span>
          </Fragment>
        }
        rootClassName="footerroot-class-name1"
        apolloPlatform={
          <Fragment>
            <span className="careers-text68">Apollo Platform</span>
          </Fragment>
        }
        buyingServices={
          <Fragment>
            <span className="careers-text69">Buying Services</span>
          </Fragment>
        }
        marginExpansion={
          <Fragment>
            <span className="careers-text70">Margin Expansion</span>
          </Fragment>
        }
        marginProtection={
          <Fragment>
            <span className="careers-text71">Margin Protection</span>
          </Fragment>
        }
        forwardDeployedEngineers={
          <Fragment>
            <span className="careers-text72">Forward Deployed Engineers</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Careers
